import { useQuery } from '@tanstack/react-query';

import { QueryOptions } from '@cast/shared-types';
import { CloudIntegration } from '@cast/types-inventory';
import { makeIsEnabled } from '@cast/utils';

import { apiClient } from '@cast/infrastructure-api';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

const CLOUD_ASSET_INTEGRATIONS_QUERY_KEY = 'cloud-asset-integrations';

export const getCloudAssetIntegrationsQueryKey = (orgId?: string) =>
  [CLOUD_ASSET_INTEGRATIONS_QUERY_KEY, orgId] as const;

type CloudAssetIntegrationsInfiniteQueryArgs = {
  options?: QueryOptions<CloudIntegration[]>;
};

export const useCloudAssetIntegrationsQuery = ({
  options,
}: CloudAssetIntegrationsInfiniteQueryArgs = {}) => {
  const { currentOrganization } = useOrganizations();
  const orgId = currentOrganization?.id;

  return useQuery({
    queryKey: getCloudAssetIntegrationsQueryKey(orgId),
    queryFn: async () => {
      const { data } = await apiClient.inventory.listCloudAssetIntegrations({
        organizationId: orgId!,
        pageLimit: '1000',
      });
      return data.items;
    },
    ...options,
    enabled: makeIsEnabled(!!orgId, options?.enabled),
  });
};
